import { render, staticRenderFns } from "./specificationPackageModal.vue?vue&type=template&id=4bcdb06d&scoped=true"
import script from "./specificationPackageModal.vue?vue&type=script&lang=js"
export * from "./specificationPackageModal.vue?vue&type=script&lang=js"
import style0 from "./specificationPackageModal.vue?vue&type=style&index=0&id=4bcdb06d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcdb06d",
  null
  
)

export default component.exports